import { ApolloClient, ApolloProvider, InMemoryCache, createHttpLink } from '@apollo/client';
import React from 'react';

const ApolloClientProvider: React.FC = ({ children }) => {
  const scaLink = createHttpLink({
    uri: '/sports/web/gbp/sca/graphql'
  });

  const client = new ApolloClient({
    link: scaLink,
    cache: new InMemoryCache()
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloClientProvider;
